export default __webpack_public_path__ + "static/avatar-65da1ac232ad07778f8d8dbdfc07dfea.jpg";